/**
 * The six data-protection commitments as a hairline-ruled numbered list.
 * design.md 8.1.7 (light) and 8.8a.2 (band).
 *
 * The strings are the `<li>` items of the `/datensicherheit` page's own list
 * block, handed in by the caller: cross-page reuse of verbatim content, never
 * retyped. No check icons, no padlocks, no shields.
 */
import { twoDigit } from '@/lib/blueprint';

export default function Pledges({
  items,
  variant = 'light',
}: {
  /** Inner html of each source `<li>`, in source order. */
  items: string[];
  variant?: 'light' | 'band';
}) {
  if (!items.length) return null;
  return (
    <ol className={`hp-pledges${variant === 'band' ? ' hp-pledges--band' : ''}`}>
      {items.map((item, index) => (
        <li className="hp-pledge" key={index}>
          <span className="hp-pledge__index" aria-hidden="true">
            {twoDigit(index + 1)}
          </span>
          <span dangerouslySetInnerHTML={{ __html: item }} />
        </li>
      ))}
    </ol>
  );
}
